<template>
  <v-app>
    <v-main>
      <table-page :headers="headers" :items="panelTests" :rowCount="25" />
    </v-main>
  </v-app>
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TablePage,
  },
  methods: {
    ...mapActions(["getPanelTests"]),
  },
  created() {
    this.$store.commit("setSearchTerm", "");
    this.getPanelTests();
  },
  computed: {
    ...mapGetters(["currentInstitution", "panelTests"]),
  },
  data() {
    return {
      headers: [
        {
          text: "Panel",
          align: "start",
          value: "panel.title",
        },
        { text: "Test", value: "test.title" },
        { text: "Created Date", value: "enabledDate" },
        { text: "Created By", value: "enablerAccount" },
      ],
      items: [],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>